<div
    class="conn-grid-3x stock-location-grid"
    *ngIf="_abd.actLocations.length > 0 && !hasVariants"
>
    <div *ngIf="_abd.actLocations.length > 0">
        <label class="control-label" style="margin-right: 15px"
            ><strong
                >Select Locations
                <span style="color: red; font-size: 1.25rem"></span> </strong
        ></label>
        <!-- [(ngModel)]="_productService.selectedLocations" -->
        <p-multiSelect
            [disabled]="!this._productService.isNew ||  _productService.isViewOnly"
            [options]="_abd.locationsBS$ | async"
            [(ngModel)]="_productService.selectedLocations"
            (onChange)="onLocationsChange($event.value)"
            optionLabel="locationName"
            display="chip"
            appendTo="body"
            [style]="{ width: '100%', 'margin-top': '10px' }"
        ></p-multiSelect>
    </div>
    <div></div>
    <div></div>
</div>

<div class="p-grid" *ngIf="!_productService.isNew && totalStockOnHands > 0">
    <div class="col-12">
        <span class="control-description text-muted">
            Total Stock On Hand: {{ totalStockOnHands }}
        </span>
    </div>
</div>

<ng-container *ngIf="!hasVariants; else variantStockManager">
    <div class="p-grid">
        <br />
        <p-table
            #dt
            [autoLayout]="true"
            [tableStyle]="{ width: '100%' }"
            [value]="_productService.selectedLocations"
            responsiveLayout="scroll"
            showLoader="true"
            rowHover="false"
            [customSort]="true"
            class="stock-table"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Location</th>
                    <th style="text-align: center; width: 200px">
                        Opening Quantity
                    </th>
                    <ng-container *ngIf="!this._productService.isNew">
                        <!-- <th style="text-align: center; width:200px;"> QOH</th> -->
                        <th style="text-align: center; width: 200px">New QOH</th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>
                        {{ item.locationName | slice : 0 : 35 }}
                        <span *ngIf="item.locationName.length > 35">...</span>
                    </td>
                    <td style="text-align: center">
                        <span class="p-input-icon-right">
                            <!-- <i class="pi pi-spin pi-spinner" ></i> -->
                            <p-inputNumber
                                [disabled]="!this._productService.isNew"
                                [ngModel]="item.openingStock ?? 0"
                                (ngModelChange)="item.openingStock = $event"
                                [min]="0"
                                [max]="calcMax(item)"
                                [inputStyle]="{
                                    'text-align': 'center',
                                    width: '100px'
                                }"
                                (onBlur)="normalizeStockValue(item, 'openingStock', true)"
                            ></p-inputNumber>
                        </span>
                    </td>
                    <ng-container *ngIf="!this._productService.isNew">
                        <!-- <td style="text-align: center">
                        <label [disabled]="true" >{{item.stockOnHandQoh}}</label>
                    </td> -->
                        <td style="text-align: center">
                            <span class="p-input-icon-right">
                                <i class="pi pi-spin pi-spinner" *ngIf="!loading"></i>
                                <p-inputNumber
                                    [(ngModel)]="item.stockOnHand"
                                    [disabled]="!this._productService.isEdit || !loading"
                                    [inputStyle]="{
                                        'text-align': 'center',
                                        width: '100px'
                                    }"
                                    (onChange)="changeQOH($event)"
                                ></p-inputNumber>
                            </span>
                        </td>
                    </ng-container>
                </tr>
            </ng-template>
        </p-table>
    </div>
</ng-container>

<ng-template #variantStockManager>
    <ng-container *ngIf="hasMultipleLocations && !useCompactVariantLayout; else singleLocationVariantStock">
        <div class="p-grid">
            <div class="col-12">
                <span class="control-description text-muted">
                    Set opening quantities per location for each variant.
                </span>
            </div>
        </div>
        <div class="p-grid">
            <div class="col-12">
                <p-table
                    [autoLayout]="true"
                    [tableStyle]="{ width: '100%' }"
                    [value]="variantRows"
                    responsiveLayout="scroll"
                    rowHover="false"
                    class="stock-table"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th [attr.rowspan]="!this._productService.isNew ? 2 : 1">Variant</th>
                            <th
                                *ngFor="let loc of variantLocations"
                                [attr.colspan]="!this._productService.isNew ? 2 : 1"
                                style="text-align: center"
                            >
                                {{ loc.locationName }}
                            </th>
                        </tr>
                        <tr *ngIf="!this._productService.isNew">
                            <ng-container *ngFor="let loc of variantLocations">
                                <th style="text-align: center; width: 200px">Opening Quantity</th>
                                <th style="text-align: center; width: 200px">New QOH</th>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ getVariantLabel(row) }}</td>
                            <ng-container *ngFor="let loc of variantLocations">
                                <td style="text-align: center">
                                    <p-inputNumber
                                        [disabled]="!this._productService.isNew || _productService.isViewOnly"
                                        [ngModel]="getVariantStockForLocation(row, loc)"
                                        (ngModelChange)="onVariantStockChangeForLocation(row, loc, $event)"
                                        [min]="0"
                                        [inputStyle]="{
                                            'text-align': 'center',
                                            width: '120px'
                                        }"
                                    ></p-inputNumber>
                                </td>
                                <td style="text-align: center" *ngIf="!this._productService.isNew">
                                    <span class="p-input-icon-right">
                                        <i class="pi pi-spin pi-spinner" *ngIf="!loading"></i>
                                        <p-inputNumber
                                            [disabled]="!this._productService.isEdit || !loading"
                                            [ngModel]="getVariantQohForLocation(row, loc)"
                                            (ngModelChange)="onVariantQohChangeForLocation(row, loc, $event)"
                                            [min]="0"
                                            [inputStyle]="{
                                                'text-align': 'center',
                                                width: '120px'
                                            }"
                                        ></p-inputNumber>
                                    </span>
                                </td>
                            </ng-container>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </ng-container>

    <ng-template #singleLocationVariantStock>
        <div class="p-grid">
            <div class="col-12 md:col-4">
                <label class="control-label">
                    <strong>Location for Variant Stock</strong>
                </label>
                <p-dropdown
                    [options]="_productService.selectedLocations"
                    [(ngModel)]="activeVariantLocation"
                    optionLabel="locationName"
                    [filter]="enableVariantLocationSearch"
                    [disabled]="_productService.isViewOnly || !_productService.selectedLocations?.length"
                    [style]="{ width: '100%', 'margin-top': '10px' }"
                    placeholder="Select location"
                    appendTo="body"
                    (onChange)="onVariantLocationSelect($event.value)"
                ></p-dropdown>
                <span class="control-description text-muted">
                    Set opening quantities per location for each variant.
                </span>
            </div>
        </div>
        <div class="p-grid" *ngIf="activeVariantLocation">
            <div class="col-12">
                <p-table
                    [autoLayout]="true"
                    [tableStyle]="{ width: '100%' }"
                    [value]="variantRows"
                    responsiveLayout="scroll"
                    rowHover="false"
                    class="stock-table"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Variant</th>
                            <th style="text-align: center; width: 200px">
                                Opening Quantity
                            </th>
                            <th
                                *ngIf="!this._productService.isNew"
                                style="text-align: center; width: 200px"
                            >
                                New QOH
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ getVariantLabel(row) }}</td>
                            <td style="text-align: center">
                                <p-inputNumber
                                    [disabled]="!this._productService.isNew || _productService.isViewOnly"
                                    [ngModel]="getVariantStock(row)"
                                    (ngModelChange)="onVariantStockChange(row, $event)"
                                    [min]="0"
                                    [inputStyle]="{
                                        'text-align': 'center',
                                        width: '120px'
                                    }"
                                ></p-inputNumber>
                            </td>
                            <td
                                *ngIf="!this._productService.isNew"
                                style="text-align: center"
                            >
                                <span class="p-input-icon-right">
                                    <i class="pi pi-spin pi-spinner" *ngIf="!loading"></i>
                                    <p-inputNumber
                                        [disabled]="!this._productService.isEdit || !loading"
                                        [ngModel]="getVariantQoh(row)"
                                        (ngModelChange)="onVariantQohChange(row, $event)"
                                        [min]="0"
                                        [inputStyle]="{
                                            'text-align': 'center',
                                            width: '120px'
                                        }"
                                    ></p-inputNumber>
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        <div class="p-grid" *ngIf="!activeVariantLocation">
            <div class="col-12">
                <span class="control-description text-muted">
                    Select a location to enter variant quantities.
                </span>
            </div>
        </div>
    </ng-template>
</ng-template>

<div class="conn-grid" *ngIf="_abd.actLocations.length === 0">
    <span class="control-description text-muted">
        No location exists to manage Stock, please add location first!</span
    >
    <br />
    <p-button (onClick)="gotoaddlocation()">Add Location</p-button>
</div>
